module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/store_images/4_be24be345bf79cc2c4599313f0d21161.png";